import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFetch } from "../hooks/useFetch";
import { apiEndpoints, API_BASE_URL } from "../utils/api";

export const Header = () => {
  const [searchVisible, setSearchVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  // Cargar configuraciones del sitio (MANTENER ORIGINAL)
  const {
    data: settings,
    loading: settingsLoading,
    error: settingsError,
  } = useFetch(apiEndpoints.settings.public());

  // Cargar menú principal (MANTENER ORIGINAL)
  const {
    data: menu,
    loading: menuLoading,
    error: menuError,
  } = useFetch(apiEndpoints.menus.single(1)); // Asumiendo que el menú principal tiene ID 1

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/buscar?q=${encodeURIComponent(searchTerm)}`);
      setSearchVisible(false);
      setSearchTerm("");
    }
  };

  const handleLoginClick = () => {
    window.location.href = '/login.php';
  };

  // Datos por defecto mientras cargan las APIs
  const siteData = {
    name: settings?.site?.name || "Red Arauca",
    logo: settings?.site?.logo || null,
    email: settings?.contact?.email || "info@sitio.com",
    phone: settings?.contact?.phone || "+57 123 456 7890",
    social: {
      facebook: settings?.social?.facebook || null,
      twitter: settings?.social?.twitter || null,
      youtube: settings?.social?.youtube || null,
      instagram: settings?.social?.instagram || null,
    },
  };

  // Menú por defecto
  const menuItems = menu?.items || [
    { id: 1, title: "Inicio", url: "/" },
    { id: 2, title: "Noticias", url: "/categoria/noticias" },
    { id: 3, title: "Miembros", url: "/miembros" },
    { id: 4, title: "Nosotros", url: "/nosotros" },
    { id: 5, title: "Contacto", url: "/contacto" },
  ];

  return (
    <>
      <style jsx>{`
        /* Reset para evitar desbordamiento */
        * {
          box-sizing: border-box;
        }

        body {
          overflow-x: hidden;
        }

        .header-top {
          background: linear-gradient(135deg, #065f46 0%, #047857 100%);
          color: white;
          padding: 8px 0;
          font-size: 0.875rem;
          width: 100%;
        }

        .header-main {
          background: linear-gradient(135deg, #059669 0%, #047857 100%);
          position: sticky;
          top: 0;
          z-index: 50;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          width: 100%;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
          width: 100%;
        }

        .header-top-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 16px;
        }

        .contact-info {
          display: flex;
          gap: 24px;
          align-items: center;
        }

        .contact-item {
          display: flex;
          align-items: center;
          gap: 6px;
          color: #d1fae5;
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .contact-item:hover {
          color: #6ee7b7;
        }

        .social-links {
          display: flex;
          gap: 12px;
        }

        .social-link {
          color: #d1fae5;
          font-size: 1.1rem;
          transition: all 0.3s ease;
          text-decoration: none;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
        }

        .social-link:hover {
          color: white;
          background: rgba(255, 255, 255, 0.2);
          transform: translateY(-2px);
        }

        .main-nav {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 0;
          position: relative;
        }

        .logo-container {
          display: flex;
          align-items: center;
          text-decoration: none;
        }

        .logo {
          height: 60px;
          max-width: 300px;
          object-fit: contain;
        }

        .logo-text {
          color: white;
          font-size: 1.5rem;
          font-weight: bold;
          margin: 0;
        }

        .nav-menu {
          display: flex;
          align-items: center;
          gap: 32px;
        }

        .nav-menu.mobile-open {
          display: flex;
        }

        .nav-link {
          color: white;
          text-decoration: none;
          font-weight: 500;
          font-size: 0.95rem;
          transition: all 0.3s ease;
          position: relative;
          padding: 8px 0;
        }

        .nav-link::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 2px;
          background: #6ee7b7;
          transition: width 0.3s ease;
        }

        .nav-link:hover {
          color: #6ee7b7;
        }

        .nav-link:hover::after {
          width: 100%;
        }

        .nav-actions {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .search-container {
          position: relative;
        }

        .search-button,
        .login-button {
          background: rgba(220, 38, 38, 0.9);
          color: white;
          border: none;
          padding: 10px 12px;
          border-radius: 6px;
          cursor: pointer;
          font-size: 0.9rem;
          font-weight: 500;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .search-button:hover,
        .login-button:hover {
          background: #dc2626;
          transform: translateY(-1px);
        }

        .search-dropdown {
          position: absolute;
          top: 100%;
          right: 0;
          background: white;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          padding: 16px;
          width: 280px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
          z-index: 10;
          margin-top: 8px;
        }

        .search-input {
          width: 100%;
          padding: 10px 12px;
          border: 2px solid #e5e7eb;
          border-radius: 6px;
          font-size: 0.9rem;
          color: #374151;
          transition: border-color 0.3s ease;
        }

        .search-input:focus {
          outline: none;
          border-color: #059669;
        }

        .mobile-menu-button {
          display: none;
          background: none;
          border: none;
          color: white;
          font-size: 1.5rem;
          cursor: pointer;
          padding: 8px;
        }

        .error-banner {
          background: #fef2f2;
          border-left: 4px solid #dc2626;
          padding: 12px 0;
          color: #dc2626;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .nav-menu {
            gap: 24px;
          }
          .logo {
            height: 50px;
            max-width: 300px;
            object-fit: contain;
          }
        }

        @media (max-width: 768px) {
          .header-top-content {
            justify-content: center;
            text-align: center;
          }

          .contact-info {
            gap: 16px;
            flex-wrap: wrap;
            justify-content: center;
          }
          .logo {
            height: 45px;
            max-width: 250px;
            object-fit: contain;
          }
          
          .nav-menu {
            display: none;
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            background: #047857;
            flex-direction: column;
            padding: 20px;
            gap: 16px;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          }

          .mobile-menu-button {
            display: block;
          }

          .search-dropdown {
            right: -100px;
            width: 250px;
          }
          
          .login-button span:last-child {
            display: none;
          }
        }

        @media (max-width: 480px) {
          .contact-info {
            flex-direction: column;
            gap: 8px;
          }

          .social-links {
            gap: 8px;
          }

          .logo-text {
            font-size: 1.2rem;
          }

          .search-dropdown {
            right: -120px;
            width: 220px;
          }
        }
      `}</style>

      {/* Top Header */}
      <div className="header-top">
        <div className="container">
          <div className="header-top-content">
            <div className="contact-info">
              <a href={`mailto:${siteData.email}`} className="contact-item">
                <span>
                  <i className="fas fa-envelope"></i>
                </span>
                <span>{settingsLoading ? "⏳" : siteData.email}</span>
              </a>
              <a href={`tel:${siteData.phone}`} className="contact-item">
                <span>
                  <i className="fas fa-phone-alt"></i>
                </span>
                <span>{settingsLoading ? "⏳" : siteData.phone}</span>
              </a>
            </div>

            <div className="social-links">
              {siteData.social.facebook && (
                <a
                  href={siteData.social.facebook}
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Facebook"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
              )}
              {siteData.social.twitter && (
                <a
                  href={siteData.social.twitter}
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Twitter"
                >
                  <i className="fab fa-twitter"></i>
                </a>
              )}
              {siteData.social.instagram && (
                <a
                  href={siteData.social.instagram}
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Instagram"
                >
                  <i className="fab fa-instagram"></i>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="header-main">
        <div className="container">
          <div className="main-nav">
            {/* Logo */}
            <Link to="/" className="logo-container">
              {siteData.logo ? (
                <img
                  src={`${API_BASE_URL}${siteData.logo}`}
                  alt={siteData.name}
                  className="logo"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "block";
                  }}
                />
              ) : null}
              <h1
                className="logo-text"
                style={{ display: siteData.logo ? "none" : "block" }}
              >
                {settingsLoading ? "⏳ Cargando..." : siteData.name}
              </h1>
            </Link>

            {/* Desktop Menu */}
            <div className={`nav-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
              {menuLoading ? (
                <span style={{ color: "white" }}>⏳ Cargando menú...</span>
              ) : menuError ? (
                <span style={{ color: "white" }}>⚠ Error menú</span>
              ) : (
                menuItems.map((item) => (
                  <Link
                    key={item.id}
                    to={item.url || "#"}
                    className="nav-link"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {item.title}
                  </Link>
                ))
              )}
            </div>

            {/* Actions */}
            <div className="nav-actions">
              {/* Search */}
              <div className="search-container">
                <button
                  onClick={() => setSearchVisible(!searchVisible)}
                  className="search-button"
                  title="Buscar"
                >
                  <i className="fas fa-search"></i>
                </button>
                {searchVisible && (
                  <div className="search-dropdown">
                    <form onSubmit={handleSearch}>
                      <input
                        type="text"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Buscar..."
                        className="search-input"
                        autoFocus
                      />
                    </form>
                  </div>
                )}
              </div>

              {/* Login Button */}
              <button className="login-button" title="Ingresar" onClick={handleLoginClick}>
                <span>
                  <i className="fas fa-sign-in-alt"></i>
                </span>
                <span>Ingresar</span>
              </button>

              {/* Mobile Menu Button */}
              <button
                className="mobile-menu-button"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                title="Menú"
              >
                {mobileMenuOpen ? "✕" : "☰"}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Error Messages - Solo en desarrollo */}
      {process.env.NODE_ENV === "development" &&
        (settingsError || menuError) && (
          <div className="error-banner">
            <div className="container">
              {settingsError && <div>⚠ Error Settings: {settingsError}</div>}
              {menuError && <div>⚠ Error Menu: {menuError}</div>}
            </div>
          </div>
        )}
    </>
  );
};